import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.MatchBankAccountWithXeroPopup.NewXeroBankAccountForm', {
    accountCustomName: 'Account custom name',
    accountNumber: 'Account number',
    cancel: 'Cancel',
    create: 'Create',
    currency: 'Currency',
    matched: 'Matched',
    newXeroBankAccount: 'New Xero bank account',
    sortCode: 'Sort code',
});
